import { useEffect, useRef } from "react";
import { ArrowRight, ChevronLeft, ChevronRight, Instagram } from "lucide-react";
import { Link } from "react-router-dom";

const SEBRACI_IG = "https://instagram.com/sebraci.oficial";

const people = [
  ["Francisco Lima", "Consultoria e Processos Administrativos Imobiliários", "/images/especialistas/francisco-lima.jpg", SEBRACI_IG],
  ["Marta Lima", "Administração e Gestão de Processos", "/images/especialistas/marta-lima.png", SEBRACI_IG],
  ["Rianne Paixão", "Planejamento Tributário e Gestão Contábil", "/images/especialistas/rianne-paixao.png", SEBRACI_IG],
  ["Érlon Freitas", "Avaliação Imobiliária e Inferência Estatística", "/images/especialistas/erlon-freitas.jpg", "https://instagram.com/prof.erlonfreitas"],
  ["Dra. Georgia Queiroz", "Usucapião e Inventário Judicial", "/images/especialistas/georgia-queiroz.jpg", "https://instagram.com/profa.georgiaqueiroz"],
  ["Dra. Wanessa Quintela", "Direito Notarial e Documentação", "/images/especialistas/wanessa-quintela.jpg", "https://instagram.com/wanessaquintela"],
  ["Dr. Michel Freire", "Registro e Regularização Imobiliária", "/images/especialistas/michel-freire.jpg", "https://instagram.com/contratoemdia"],
  ["Eng. Patrick Araújo", "Topografia e Georreferenciamento", "/images/especialistas/patrick-araujo.jpg", "https://instagram.com/eng.patrickaraujo"],
  ["Franzé Lima", "BPO Financeiro Imobiliário", "/images/especialistas/franze-lima.jpg", SEBRACI_IG],
] as const;

export function SpecialistsCarousel({ compact = false }: { compact?: boolean }) {
  const trackRef = useRef<HTMLDivElement>(null);
  const move = (direction: 1 | -1) => {
    const track = trackRef.current;
    if (!track) return;
    if (direction === -1 && track.scrollLeft < 10) track.scrollLeft = track.scrollWidth / 2;
    track.scrollLeft += direction * Math.min(track.clientWidth * .72, 460);
  };
  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    let frame = 0;
    let previous = performance.now();
    const animate = (time: number) => {
      const elapsed = Math.min(time - previous, 40); previous = time;
      track.scrollLeft += elapsed * .055;
      const loopPoint = track.scrollWidth / 2;
      const resetPoint = Math.min(loopPoint, track.scrollWidth - track.clientWidth);
      if (track.scrollLeft >= resetPoint) track.scrollLeft = Math.max(0, track.scrollLeft - loopPoint);
      frame = requestAnimationFrame(animate);
    };
    frame = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(frame);
  }, []);
  return <div className={compact ? "embedded-faculty" : ""}><div className="faculty-carousel"><button className="faculty-arrow faculty-prev" onClick={() => move(-1)} aria-label="Especialistas anteriores"><ChevronLeft /></button><div className="faculty-track" ref={trackRef}>{[...people, ...people].map(([name, role, image, instagram], index) => <article key={`${name}-${index}`} aria-hidden={index >= people.length}><div className="faculty-photo"><img src={image} alt={index < people.length ? name : ""} />{instagram && <a className="specialist-instagram" href={instagram} target="_blank" rel="noreferrer" aria-label={`Instagram de ${name}`} tabIndex={index >= people.length ? -1 : 0}><Instagram /></a>}</div><div><strong>{name}</strong><span>{role}</span></div></article>)}</div><button className="faculty-arrow faculty-next" onClick={() => move(1)} aria-label="Próximos especialistas"><ChevronRight /></button></div><Link className="faculty-more" to="/especialistas">Conhecer todos os especialistas <ArrowRight /></Link></div>;
}
